import { importRepository } from "../Infrastructure/ImportFile.repository";

export async function importLogic(userId, file) {
  return importRepository(userId, file);
}
